'use strict';

const collectionFactory = require('./collection.factory');

const serviceCatalogueCollection = collectionFactory({
    dataUrl: 'getPayPremium',

    url() {
        return Odigeo.Settings.getProperty('ancillariesUrlFormatter')(this.dataUrl);
    },

    getServicePackPremium() {
        return this.get('product');
    },

    getServicePackPremiumPrice() {
        return Odigeo._.get(this.getServicePackPremium(), 'price', null);
    },

    isAnyServicePackInCart() {
        return !this.get('available');
    },
});

module.exports.getInstance = serviceCatalogueCollection.getInstance;
